<template>
    <div>
      <!-- {{  this.usuario.principal.estado }} -->
<v-container>
 <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <div class="my-2">
      <v-btn @click="dialog = true">check data</v-btn>
    </div> 

      <v-dialog
      v-model="dialog"
    >
      <v-card>
        <v-card-title>USUARIO
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-title>
          <v-card-text class="pprint">{{ usuario }}</v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  -->
 <v-row  >



<!-- INICIO SECCION -->

<v-col cols="2">

</v-col>


<v-col cols="8">


     <v-card  elevation="6">
  <v-card-title class="text-h5">
    Datos del Usuario
  </v-card-title>
  <v-card-text>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form ref="form" v-model="valid" lazy-validation>
           


 <v-text-field
              v-model="usuario.name"
              label="Usuario Nombre"
              :rules="textRules"
              required
              data-cy="name-input"
              :disabled="true"
            ></v-text-field>

                <v-text-field
   v-model="usuario.email"
   label="Correo"
   :counter="3"
   :rules="emailRules"
   required
   :disabled="true"
 ></v-text-field>


          
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>


</v-card>


</v-col>

<v-col cols="2">

  
</v-col>




<!-- FIN SECCION -->



<!-- INICIO SECCION ROLES -->

<v-col cols="2" v-if="misRolesLinks.length">
</v-col>

<v-col cols="8" v-if="misRolesLinks.length">
  <v-card elevation="6">
    <v-card-title class="text-h5">
      Mis Roles
    </v-card-title>
    <v-card-text>
      <p class="caption grey--text mb-3">Accesos rápidos según tus roles en la plataforma.</p>
      <div>
        <v-chip
          v-for="item in misRolesLinks"
          :key="item.rol"
          class="ma-1"
          color="primary"
          dark
          link
          @click="irA(item.to)"
        >
          <v-icon left small>{{ item.icon }}</v-icon>
          {{ item.text }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</v-col>

<v-col cols="2" v-if="misRolesLinks.length">
</v-col>

<!-- FIN SECCION ROLES -->






<!-- INICIO SECCION 2-->

<v-col cols="2">

</v-col>


<v-col cols="8">


     <v-card  elevation="6">
  <v-card-title class="text-h5">
    Opciones de Compartir Perfil
  </v-card-title>
 


  <!-- <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form ref="form" v-model="valid" lazy-validation>
            
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text> -->

          <v-card-actions>


            <v-row>


              <v-col cols="12">
        <v-switch
              v-model="usuario.principal.active"
               label="Habilitar visualización de Perfil por URL"
               @click="habilitarUrl()"
                ></v-switch>
</v-col>

           
              <v-col cols="12" >
          
                <v-switch
                :disabled="!usuario.principal.active"
                v-model="estadoSwitch"
              label="Habilitar compartir perfil en página principal"

              @click="solicitarPublicacion()"
               
                ></v-switch>

              </v-col>


              <v-col cols="12" class="d-flex align-center">
  <v-icon v-if="usuario.principal.verified" color="green" class="mr-2">mdi-check-circle</v-icon>
  <v-tooltip bottom v-else>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        color="orange darken-2"
        class="mr-2"
      >
        mdi-clock-alert
      </v-icon>
    </template>
    <span>
     El proceso puede demorar hasta una semana si deseas <strong>Habilitar compartir perfil en página principal</strong>. 
      Recibirás un correo cuando sea aceptada.
    </span>
  </v-tooltip>

  <span>
    {{ usuario.principal.verified ? 'Usuario verificado' : 'Verificación pendiente' }}
  </span>
</v-col>




          </v-row>


       
          </v-card-actions>



</v-card>


</v-col>

<v-col cols="2">

  
</v-col>




<!-- FIN SECCION 2-->

















        <v-col cols="2">

        </v-col>

        
        <v-col cols="8">


             <v-card  elevation="6">
          <v-card-title class="text-h5">
            Cambio de URL a mostrar de la página
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form ref="form" v-model="valid" lazy-validation>
                   

                     <v-text-field
           v-model="usuario.identificador"
           label="Identificador actual para su página"
           :counter="3"
           :rules="textRules"
           required
           
            :disabled="true"

         ></v-text-field>

         <v-text-field
           v-model="usuario.identificador_new"
           label="Identificador nuevo para su página"
           :counter="3"
           :rules="textRules"
           required
           :disabled="btn_identificador_new"
           
         ></v-text-field>

                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>

            <v-switch  label="Habilitar edición" @click="editar()"></v-switch>
            <!-- <v-btn  outlined color="orange darken-1"  text  @click="editar()">
               <v-icon>
       mdi-cancel
      </v-icon> 
              Editar
            </v-btn> -->
          

            <v-spacer></v-spacer>
            <v-btn  outlined color="red darken-1"  text  @click="limpiar"
            v-show="!btn_identificador_new"
            >
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cancelar
            </v-btn>
            <v-btn outlined text color="blue darken-4" 
            @click="edit_identificador(usuario)"
            data-cy="submit"
            v-show="!btn_identificador_new"
            >

            <v-icon>
       mdi-content-save-outline
      </v-icon> 
              Registrar
            </v-btn>
       
          </v-card-actions>



        

         


        </v-card>


        </v-col>

        <v-col cols="2">

          
        </v-col>

        <v-col cols="2">


        </v-col>

        <v-col cols="8">

          <v-card elevation="6">

            <v-card-title class="text-h5">
            Gestión Avanzada
          </v-card-title>

          

<v-row>

  
<v-col cols="12" sm="12" lg="12" class="d-flex flex-column justify-center align-right">


</v-col>

      
<v-col cols="6" sm="6" lg="6" class="d-flex flex-column justify-start align-start">

<PassDialog 
class="pa-2"
outlined
tile
:usuarioData="usuario"
@seleccionarUsuario="recibirUsuario"></PassDialog>

<ConfirmEliminarDialog 
class="pa-2"
outlined
tile
:usuarioData="usuario"
@seleccionarUsuario="recibirUsuario"></ConfirmEliminarDialog>



</v-col>





<v-col cols="6" sm="6" lg="6" class="d-flex flex-column justify-center align-right">


</v-col>


</v-row>

</v-card>

        </v-col>

        <v-col cols="2">

        </v-col>


      </v-row>


      <v-container>

        
      </v-container>


</v-container>



    </div>



</template>




<script>
import usuarioService from "@/services/usuarioService.js";

import principalService from "@/services/principalService.js";

import axios from 'axios'

import PassDialog from '@/components/auto_register/gestion/PassDialog';


import ConfirmEliminarDialog from '@/components/auto_register/gestion/ConfirmEliminarDialog';

//import UsuarioDialog from '@/components/auto_register/gestion/UsuarioDialog.vue';



import router from "@/router/index";



export default {
     name: 'DatosUsuario',
    
  components: {
   //UsuarioDialog

      PassDialog,
    ConfirmEliminarDialog
  }
  ,
    data: vm => ({
      dialog: false,
      botonDeshabilitado: false,
      btn_identificador_new:true,
      btn_name:true,
      token:'',
      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 10000,
      },
    valid: true,
    buscador:'',
showPass: false,
  usuarios: [],
        usuario:{
id:'',
name:'',
email:'',
identificador:'',
identificador_new:'',
password:'',
principal:{

id:'',
nombre:'',
apellido:'',
identificador:'',
descripcion:'',
linkPhoto:'',
observacion:'',
linkVideo:'',
zoom:50,

}
        },

        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ]
        
    
  }),
  created(){

       }
  ,mounted(){


this.obtenerUsuario();
    

   
    },

  methods: {

    async recaptcha() {
  try {
    // Espera hasta que reCAPTCHA esté listo
    await this.$recaptchaLoaded();

    // Ejecuta la verificación con la acción "login"
    const token = await this.$recaptcha('login');

    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; // Lanza el error para manejarlo externamente
  }
},

    editar(){

        this.btn_identificador_new=!this.btn_identificador_new;

        this.btn_name=!this.btn_name;
      
      
    },

    irA(ruta) {
      this.$router.push(ruta);
    },


    recibirUsuario:function(usuario){

      console.log('En elemento padre Principal');
      //  console.log(principalOpcion);
     

    },

    obtenerUsuario(){

var newIdentificador = localStorage.getItem('identificador'); // Recupera el identificador del localStorage
      if (newIdentificador) {
         newIdentificador =localStorage.getItem('identificador');
      } else {
        console.error('No se encontró el identificador en localStorage');
      }

            
    usuarioService.obtenerUsuarioPorIdentificador(newIdentificador).then(
        response =>{
           
            this.usuario=response.data.user;
            console.log(this.usuario);
            console.log('success');

            console.log(response);
          
        }).catch((errors) =>{
          //  let desc='';
         //   res = errors.response.data.status;
         //   errors.response.data.errors.map( (e) =>{ desc= desc+' '+e})
           console.log('error');
            console.log(errors);

//console.log(errors.message);
           
        })

    
    },



    registrar(){
    if (this.$refs.form.validate()) {
   
       // console.log(this.usuario);

                  //Enviar a store/index en vuex el valor de usuario
                  //quitar la seña antes
        

          usuarioService.save(this.usuario).then(response=>{
         
              alert('Usuario registrado exitosamente!!')

           //   console.log(response.data.data.token);
          this.token = response.data.data.token;
          localStorage.setItem("token", this.token);
            

  //this.usuario.password='';
          //this.$store.commit('setUsuario', this.usuario);
        //  console.log(response.data);
      //    console.log(response.data.data.identificador);
          router.push("perfil/"+response.data.data.identificador+"/add"); 




  this.limpiar();

          });


        
      }
    },

   async edit_identificador(usuario){


      try {
      const token = await this.recaptcha(); // Espera hasta que recaptcha() termine


     // console.log('Token obtenido:', token);
      this.usuario.recaptcha=token;


    } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }








    if (this.$refs.form.validate()) {
   
     //   console.log(usuario);

                  //Enviar a store/index en vuex el valor de usuario
                  //quitar la seña antes
        
                //  let identificador_old=localStorage.getItem('identificador');

          usuarioService.edit_identificador(usuario).then(response=>{
         



this.mensaje.text="Usuario editado exitosamente";

this.mensaje.color="primary";
this.mensaje.colorBtn="blue";

this.mensaje.snackbar="true";



             alert('Usuario editado exitosamente!!')

           //   console.log(response.data.data.token);
          this.token = response.data.data.token;
          localStorage.setItem("token", this.token);

          localStorage.setItem("identificador", response.data.data.identificador);
            

  //this.usuario.password='';
          //this.$store.commit('setUsuario', this.usuario);
          console.log(response.data);
          console.log(response.data.data.identificador);
          router.push("perfil/"+response.data.data.identificador+"/add"); 




  this.limpiar();

            }).catch(e=>{



console.log(e.response.message);

let mensajeError = '';


//console.log(e.response.data.message);
if (e.response && e.response.data) {
      const errors = e.response.data; // Accede a 'data' en la respuesta
      if (errors) {
      //  console.log(errors.email[0]); // "The email has already been taken."



        mensajeError += "\n"+""+errors.message;

        
      }else{
        console.log(errors.message);
      }

    }



    //alert('Mensaje: '+mensajeError);

  this.mensaje.text=mensajeError;

this.mensaje.snackbar="true";

this.mensaje.color="error";
this.mensaje.colorBtn="error";

});



        
      }
    }

    ,
    limpiar(){

     
		this.usuario.name='',
        this.usuario.identificador_new=''
	

        
    },
  recibirUsuario:function(usuario){

      console.log('En elemento padre Redact despues de editar');
        console.log(usuario);
 
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    recibirUsuarioOpcion:function(usuarioOpcion){

      console.log('En elemento padre Usuario');
        console.log(usuarioOpcion);
     

    },
    habilitarUrl(){



      //this.usuario.principal.active= !this.usuario.principal.active;

      console.log(this.usuario.principal.active);


    //  setTimeout(() => {

        usuarioService.cambiarEstado(this.usuario).then(
        response =>{
           
            this.usuario=response.data.user;
            console.log(this.usuario);
            console.log('success');

            console.log(response);
          
        }).catch((errors) =>{
           console.log('error');
            console.log(errors);

           
        })

    //  }, 500); // Tiempo en milisegundos
    

      


    },solicitarPublicacion(){

  //    this.usuario.principal.active='1';


        usuarioService.solicitarPublicacion(this.usuario).then(
        response =>{
           
            this.usuario=response.data.user;


            //Como mostrar en caso de required

            //Como mostrar en caso de public

            //Al habilitar enviar un correo a futuro.


            console.log(this.usuario);
            console.log('success');

            console.log(response);
          
        }).catch((errors) =>{

          
           console.log('error');
            console.log(errors);




            if (errors.response && errors.response.status === 403) {
      console.log('Correo no verificado');


        this.mensaje.text='Verifique su correo electronico para publicar su perfil en la página principal';

        this.estadoSwitch=false;

this.mensaje.snackbar="true";

this.mensaje.color="error";
this.mensaje.colorBtn="error";

      
      // Puedes mostrar un mensaje con Vuetify, por ejemplo:
     // this.$toast.error('Tu correo no está verificado');
    } else {
      console.log('Otro error:', errors);
    }

           
        })
    }



  },

    watch: {
      date (val) {
        
		
       
      },
    },
    computed: {
  misRolesLinks() {
    const roles = this.$store.getters.userRoles || [];
    const roleMap = [
      { rol: 'admin', text: 'Panel Admin (Ecommerce)', to: '/ecommerce', icon: 'mdi-shield-account' },
      { rol: 'seller', text: 'Ecommerce', to: '/ecommerce', icon: 'mdi-store' },
      { rol: 'author', text: 'Foro Admin', to: '/forum-admin', icon: 'mdi-forum' },
      { rol: 'links', text: 'LinksTec Admin', to: '/linkstec-admin', icon: 'mdi-link-variant' },
    ];
    return roleMap.filter(item => roles.includes(item.rol));
  },
  estadoSwitch: {
    get() {
      // El switch aparece como activado solo si el estado NO es 'disabled'
      return this.usuario.principal.estado !== 'disabled';
    },
    set(val) {
      if (val) {
        // Al activar el switch: asignar 'public' o 'required' según verified
        this.usuario.principal.estado = this.usuario.principal.verified
          ? 'public'
          : 'required';
      } else {
        // Al desactivar el switch: asignar 'disabled'
        this.usuario.principal.estado = 'disabled';
      }

      console.log('Estado actual:', this.usuario.principal.estado);
    }
  }
}

};
</script>



<style scoped>

.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>